if (!customElements.get('pdp-video')) {
  class PdpVideo extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('.pdp-video__button');
      this.modal = this.querySelector('.pdp-video__modal');
      this.close = this.querySelector('.pdp-video__close');
      this.video = this.querySelector('.pdp-video__video');


      // Store the original parent and next sibling to restore position
      this.originalParent = this.modal.parentElement;
      this.originalNextSibling = this.modal.nextSibling;

      // Event listener to open the modal
      this.button.addEventListener('click', (event) => {
  const buttonLink = this.button.getAttribute('data-button-link');

  if (buttonLink) {
    event.preventDefault();

    if (this.button.getAttribute('data-open-new-tab') === 'true') {
      window.open(buttonLink, '_blank', 'noopener,noreferrer');
    } else {
      window.location.href = buttonLink;
    }

    return;
  }

  this.openModal();
});

      // Event listener to close the modal
      this.close.addEventListener('click', () => {
        this.closeModal();
      });

      // Event listener to close the modal on click outside the modal
      this.modal.addEventListener('click', (event) => {
        if (event.target === this.modal) {
          this.closeModal();
        }
      });
    }

    openModal() {
      this.modal.setAttribute('data-active', ''); // Set data-active on modal
      document.body.style.overflow = 'hidden'; // Disable scrolling
      document.body.appendChild(this.modal); // Move modal to the end of the body
      this.video.currentTime = 0;// Play video
      this.video.play();
    }

    closeModal() {
      this.modal.removeAttribute('data-active'); // Remove data-active from modal
      document.body.style.overflow = ''; // Restore scrolling

      // Restore the modal to its original position
      if (this.originalNextSibling) {
        this.originalParent.insertBefore(this.modal, this.originalNextSibling);
      } else {
        this.originalParent.appendChild(this.modal);
      }
      this.video.pause(); // Stop video
      this.video.currentTime = 0;
    }
  }

  customElements.define('pdp-video', PdpVideo);
}
